export default {
  title: 'digital-resources',
  version: '0.0'
}